import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import StarterKit from "@tiptap/starter-kit";
import FontFamily from "@tiptap/extension-font-family";
import TextStyle from "@tiptap/extension-text-style"; // Required for font styles
import {
  MenuButtonBold,
  MenuButtonBulletedList,
  MenuButtonItalic,
  MenuButtonOrderedList,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  RichTextEditor,
} from "mui-tiptap";
import EditorMenuControls from "./EditorMenuControls";
import { useExtensions } from "./useExtensions";

const RichTextInput = (props) => {

  //#region props
  const { 
    name, 
    value,
    onChange,
    readOnly
  } = props;

  //#region refs
  const editorRef = useRef(null);
  const extensions = useExtensions({
    placeholder: '',
  });

  //#region effects
  useEffect(() => {
    const editor = editorRef.current?.editor;
    if (!editor) return;

    // Update editor content if value changes externally
    if (editor.getHTML() !== value) {
      editor.commands.setContent(value || "", false);
    }

    const updateHandler = () => {
      const html = editor.getHTML();
      onChange(name, html);
    };

    editor.on("update", updateHandler);

    return () => {
      editor.off("update", updateHandler);
    };
  }, [onChange, name, value]);

  //#region return
  return (
    <div>
      {
        readOnly
        ? <RichTextEditor
            ref={editorRef}
            content={value}
            editable={false}
            extensions={[StarterKit]} />
        : <RichTextEditor
            ref={editorRef}
            content={value}
            extensions={[StarterKit]}
            renderControls={() => (
              <MenuControlsContainer>
                <MenuSelectHeading />
                <MenuDivider />
                <MenuButtonBold />
                <MenuButtonItalic />
                <MenuDivider />
                <MenuButtonOrderedList />
                <MenuButtonBulletedList />
              </MenuControlsContainer>
            )} />
      }
    </div>
  );
};

RichTextInput.defaultProps = {
  name: "",
  value: "",
  onChange: () => {},
  readOnly: false,
};

RichTextInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default RichTextInput;
